module.exports = __webpack_public_path__ + "img/ico-my-pc.93770081.png";